import React, { useEffect, useState, useCallback } from 'react';
import { Section } from '../layout';
import { useTranslation } from 'react-i18next';
import { useSelector, useDispatch } from 'react-redux';
import { getFillterBlogs, deleteBlog, ClearBlog } from '../../redux/actions/blogs';
import { toast } from 'react-toastify';
import { useNavigate } from "react-router-dom";

import axios from "axios"
import { DataGrid } from '@mui/x-data-grid';
import {

  ViewButtonStyle,
  ViewonBlur,
  ViewonFocus,
  ViewonMouseEnter,
  ViewonMouseLeave,
  localeTextGrid,
} from "../../constants";
import { ThemeProvider, createTheme } from '@mui/material';
import { useStateContext } from '../../context/ContextProvider';
import { BaseUrl, media } from '../../server';
import { SpinButton, Spiner } from '../utils/Form';
import {truncateTitle} from "../../middleware/truncateTitle"
import { Button } from "@mui/material";


import { getFillterPleadings, getUserPleadings } from '../../redux/actions/pleading';
import { renderText, truncateText } from '../hooks/TextVeiw';

import { Loader } from '../utils';
function UAllpladings() {
  const { t } = useTranslation();
  const dispatch = useDispatch();
  const { currentDir } = useStateContext();
  const [isSpinner, setIsSpinner] = useState(false);
  const [date, setDate] = useState('');
  const [pleadingNumber, setPleadingNumber] = useState('')  
 
  const [clientName , setClientName] = useState('')
const [opponentName ,setOpponentName]=useState("")
 const [caseNumber ,setCaseNumber]=useState("")
  const [pleadingName, setPleadingName] = useState('');
  const navigate = useNavigate();
  const [paginationModel, setPaginationModel] = useState({
    pageSize: 10,
    page: 0,
  });

  const page = paginationModel.page;
  const limit = paginationModel.pageSize;


  useEffect(() => {
   
    dispatch(getUserPleadings(page, limit));
  }, [page, limit,dispatch]);

  const { isLoading, Userpleadings, pagination } = useSelector((state) => state.Pleadings);


const ViewPleadindHandeler=(id)=>{
  navigate(`/userPleadingsDetails/${id}`)
}
  const theme = createTheme({
    direction: currentDir
  });

  const totalPages = pagination?.totalPages || 0;
  const totalItems = pagination?.totalItems || 0;
  
  const columns = [
    {
      field: 'caseId',
      headerName: t('case Number'),
      headerClassName: 'font-semibold text-sm font-kufi',
      width: 120,
      filterable: false,
      renderCell: (params) => {
        return (
          <div className="flex items-center pt-4">
            <p className="font-medium text-sm font-kufi">{params.value.caseNumber}</p>
          </div>
        )
      }
    },
    {
      field: 'pleadingNumber',
      headerName: t('Pleading Number'),
      headerClassName: 'font-semibold text-sm font-kufi',
      width: 120,
      filterable: false,
      renderCell: (params) => {
        return (
          <div className="flex items-center pt-4">
            <p className="font-medium text-sm font-kufi">{params.value}</p>
          </div>
        )
      }
    },
    {
      field: 'pleadingName',
      headerName: t('Pleading Name'),
      headerClassName: 'font-semibold text-sm font-kufi',
      width: 200,
      filterable: false,
      renderCell: (params) => {
        return (
          <div className="flex items-center pt-4">
                <p className="font-medium text-sm font-kufi">{truncateTitle(params.value , 3)}</p>
          </div>
        )
      }
    },
   
    {
      field: 'clientName',
      headerName: t('client Name'),
      headerClassName: 'font-semibold text-sm font-kufi',
      width: 200,
      filterable: false,
      renderCell: (params) => {
        return (
          <div className="flex items-center pt-4">
                <p className="font-medium text-sm font-kufi">{truncateTitle(params.value , 3)}</p>
          </div>
        )
      }
    },
    {
      field: 'opponentName',
      headerName: t('opponent Name'),
      headerClassName: 'font-semibold text-sm font-kufi',
      width: 200,
      filterable: false,
      renderCell: (params) => {
        return (
          <div className="flex items-center pt-4">
                <p className="font-medium text-sm font-kufi">{truncateTitle(params.value , 3)}</p>
          </div>
        )
      }
    },

    {
      field: 'date',
      headerName:  t('Date') ,
      headerClassName: 'font-semibold text-sm font-kufi',
      width: 120,
   
      filterable: false,
      renderCell: (params) => {
        return (
          <div className="flex items-center">
            <p className="font-kufi">{params.value} </p>
          </div>
        )
      }
    },

    {
      field: 'actions',
      headerName: t('Actions') ,
      headerClassName: 'font-semibold text-sm font-kufi',
      width: 75,
      filterable: false, 
      renderCell: (params) => {
        return (<>
   <div className="flex pt-2 w-[150px] gap-2 items-center ">


<Button className="rounded-full"
        style={ViewButtonStyle}
        onMouseEnter={ViewonMouseEnter}
        onMouseLeave={ViewonMouseLeave}
        onFocus={ViewonFocus}
        onBlur={ViewonBlur} 
        onClick={() => ViewPleadindHandeler(params.row._id)}
        >
         <span className='body-2'>{t("View")}</span> 
</Button>     
   </div>
        
         </>
        );
      }
    },
  ];



  return (
    <>
      {isLoading ? (
        <Loader />
      ) : (

        <div className="flex-col  lg:p-16 py-14 px-5 w-full items-center ">
        <h2 className="h2 text-color-1 text-center  dark:text-tcolor-1 mb-4 md:mb-8">{t("All Pleadings")}</h2>

            <div className=" items-center  relative justify-center  md:m-10 mt-24 p-2 md:p-10 h-auto bg-white rounded-3xl">
  <ThemeProvider theme={theme}>
    <div style={{ width: '100%', overflowX: 'auto' }}>
                <DataGrid
                  rows={Userpleadings}
                  columns={columns}
                  disableRowSelectionOnClick
                  sx={{ minWidth: '1200px' }}     
                  pagination
                  paginationMode="server"
                  rowCount={totalItems} // Total number of items
                  paginationModel={paginationModel}
                  onPaginationModelChange={setPaginationModel}
                  pageSizeOptions={[paginationModel.pageSize]}
                  getRowId={(row) => row._id} // Use _id as the unique identifier
                  localeText={localeTextGrid} // تمرير الترجمات
                />
             </div>
  </ThemeProvider>
</div></div>
      )}
    </>
  );
}

export default UAllpladings;